import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus } from '@apollo/client'
import CardWidget, { Colors } from '../../../components/CardWidget'
import CardWidgetSkeleton from '../../../components/skeletons/CardWidgetSkeleton'
import { FactoryFiltersContext } from '../../../context/FactoryFiltersContext'
import { GET_ORDER_QUANTITY } from '../../../queries/factory'
import { formatNumber } from '../../../utils/Helpers'

const OrdersQuantity = (): JSX.Element => {
  const { filters } = useContext(FactoryFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_ORDER_QUANTITY, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { filters }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <CardWidgetSkeleton />
  if (loading || !data) return <CardWidgetSkeleton />
  if (error) return <p>Error :(</p>

  return (
    <CardWidget title="Quantidade de pedidos" number={formatNumber(data.aggregation.aggregations.ordersQuantity.value, 0)} color={Colors.green} />
  )
}

export default OrdersQuantity
